import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { AuditsCard } from "./card";
import { setDocumentTitle } from "@/lib/documentTitle";

import { AuditsTable } from "./table";

export default function Audits() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Historique des modifications");
  }, []);

  return (
    <Routes>
      <Route index element={<AuditsTable />} />
      <Route path=":id" element={<AuditsCard />} />
    </Routes>
  );
}
